// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"83582846","232":"ddbdfab7","237":"321cd46c","526":"8f5f0e0c","787":"54ac61fc"}[chunkId] + ".chunk.js";
};